import AppContext from 'context/Context';
import {
  getDefaultNavbarStyle,
  hasNavbarStylePreference,
  isOrgAdmin
} from 'helpers/themeConfig';
import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';

const useOrgAdminNavbarStyle = () => {
  const userRoles = useSelector(state => state.authentication?.userRoles ?? []);
  const {
    config: { navbarStyle },
    setConfig
  } = useContext(AppContext);

  useEffect(() => {
    if (!isOrgAdmin(userRoles) || hasNavbarStylePreference()) {
      return;
    }

    const defaultStyle = getDefaultNavbarStyle(userRoles);
    if (navbarStyle !== defaultStyle) {
      setConfig('navbarStyle', defaultStyle);
    }
  }, [userRoles, navbarStyle, setConfig]);
};

export default useOrgAdminNavbarStyle;
